import React from 'react';
import Sidebar from '../components/Sidebar';
import { Globe, Rss } from 'lucide-react';

const Sources = () => {
  return (
    <div className="flex h-screen bg-slate-50 font-inter text-blue-900 overflow-hidden">
      <Sidebar />
      <main className="flex-1 p-12 overflow-y-auto">
        <header className="mb-12 flex justify-between items-end">
          <div>
            <h1 className="text-3xl font-black uppercase tracking-tighter italic">
              AI FINE <span className="text-blue-600">PROTECTOR ™</span>
            </h1>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-2">
              Global Regulatory Sources
            </p>
          </div>
          <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-xl shadow-lg shadow-blue-100">
            <Rss size={14} className="animate-pulse" />
            <span className="text-[9px] font-black uppercase tracking-widest">Live Updates</span>
          </div>
        </header>

        <div className="bg-white p-12 rounded-[3rem] shadow-sm border border-slate-100 italic font-bold text-slate-400 text-sm">
          Regulatory intelligence feed is initializing...
        </div>
      </main>
    </div>
  );
};

export default Sources;